import useCounter from './use-counter';
export default function useCountDown({ time = 0, format = '', onFinish, duration = 1000, }) {
    return useCounter({
        time,
        format,
        onFinish,
        duration,
        countDown: true,
    });
}
